(function () {
  function initBrandCarousel(carousel) {
    if (carousel.dataset.carouselInit === 'true') return;
    carousel.dataset.carouselInit = 'true';

    var track = carousel.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-slide]'));
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');

    if (!track || slides.length === 0) return;

    var centerSlide = slides[0];
    var hoveredSlide = null;

    function getTrackCenter() {
      var trackRect = track.getBoundingClientRect();
      return trackRect.left + trackRect.width / 2;
    }

    function getClosestSlide() {
      var trackCenter = getTrackCenter();
      var closestSlide = slides[0];
      var closestDistance = Infinity;

      slides.forEach(function (slide) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var distance = Math.abs(trackCenter - slideCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestSlide = slide;
        }
      });

      return closestSlide;
    }

    function setActiveSlide(slide) {
      centerSlide = slide;
      slides.forEach(function (item) {
        item.classList.toggle('is-active', item === slide);
      });
    }

    function setHoverSlide(slide) {
      if (!slide || hoveredSlide === slide) return;

      hoveredSlide = slide;
      carousel.classList.add('is-hovering');
      slides.forEach(function (item) {
        item.classList.toggle('is-hover-active', item === slide);
      });
    }

    function clearHoverSlide() {
      if (!hoveredSlide) return;

      hoveredSlide = null;
      carousel.classList.remove('is-hovering');
      slides.forEach(function (item) {
        item.classList.remove('is-hover-active');
      });
      setActiveSlide(getClosestSlide());
    }

    function updateActiveSlide() {
      if (hoveredSlide) return;
      setActiveSlide(getClosestSlide());
    }

    function scrollSlideIntoCenter(slide) {
      var targetLeft = slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
      track.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: 'smooth'
      });
    }

    function scrollByOneSlide(direction) {
      clearHoverSlide();

      var activeIndex = slides.indexOf(centerSlide);
      if (activeIndex === -1) {
        activeIndex = slides.indexOf(getClosestSlide());
      }

      var nextIndex = activeIndex + direction;
      if (nextIndex < 0 || nextIndex >= slides.length) return;

      scrollSlideIntoCenter(slides[nextIndex]);
    }

    slides.forEach(function (slide) {
      slide.addEventListener('mouseenter', function () {
        setHoverSlide(slide);
      });
    });

    carousel.addEventListener('mouseleave', clearHoverSlide);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByOneSlide(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByOneSlide(1);
      });
    }

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveSlide, 50);
    });

    window.addEventListener('resize', updateActiveSlide);

    setActiveSlide(getClosestSlide());
  }

  function initAllCarousels() {
    document.querySelectorAll('[data-brand-carousel]').forEach(initBrandCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var carousel = event.target.querySelector('[data-brand-carousel]');
    if (carousel) initBrandCarousel(carousel);
  });
})();
